import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 16px 16px 16px;
`;

export const Action = styled.button`
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  font-size: 18px;
  font-family: ${({ theme }) => theme.typography.primary.bold};
  color: ${({ theme }) => theme.colors.lightBlue};
  outline: none;
  margin-left: 32px;
  appearance: none;
  border: none;
  background-color: transparent;
  border-radius: 4px;
  padding: 4px;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }
`;
